import { IconButton } from "@mui/material";
import {
  DatePicker,
  DateValidationError,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import "./SingleDatePicker.scss";
import { SingleDatePickerProps } from "../../../core/models/datePickersComponent/datePickersComponent.model";

const SingleDatePicker = ({
  maxDate,
  appliedDay,
  setAppliedDay,
  disabled = false,
  disableFuture = false,
  disablePast = false,
  error,
  setError,
  customDateError,
}: SingleDatePickerProps) => {
  const { t } = useTranslation();

  const errorMessage = (errors: DateValidationError) => {
    if (customDateError) {
      for (let err of customDateError) {
        switch (errors) {
          case err.errorType: {
            return err.text;
          }
        }
      }
    }

    switch (errors) {
      case "disableFuture":
      case "disablePast":
      case "invalidDate":
      case "minDate":
      case "maxDate": {
        return t("Datepicker.Introduzca una fecha válida");
      }

      default: {
        return "";
      }
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <DatePicker
        className="date-picker"
        disablePast={disablePast}
        disableFuture={disableFuture}
        maxDate={maxDate ? maxDate : undefined}
        onChange={setAppliedDay}
        disabled={disabled}
        value={appliedDay}
        onError={(newError) => {
          setError(newError === null ? "" : newError);
        }}
        slotProps={{
          textField: {
            error: !!error,
            helperText: (() => {
              const errorText = error
                ? errorMessage(error as DateValidationError)
                : "";
              return errorText;
            })(),
            InputProps: {
              placeholder: t("Seleccionar"),
              sx: {},
              startAdornment: appliedDay && (
                <IconButton
                  sx={{ position: "absolute", right: "2rem" }}
                  onClick={() => setAppliedDay(null)}
                >
                  <span className="t-icon-close" />
                </IconButton>
              ),
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default SingleDatePicker;
